import React from 'react'
// import { useToast } from '@chakra-ui/react'
// import './Mindprobe_Results.css';

const Results = () => {
    // const toast = useToast()

    return (
        <div id='mindprobe_results'>
            <h1 id='title'>Results</h1>
            <div id='container'>
                <div id='leaderboard'>
                    <h1 id='leaderboard_title'>Leaderboard</h1>
                    <div id='leaderboard_container'>
                        <div id='senior'>
                            <h1 id='category_title'>Senior</h1>
                            <div id='table_container'>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Rank</th>
                                            <th>School</th>
                                            <th>Score</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>D.S. Senanayake College</td>
                                            <td>85</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Richmond College</td>
                                            <td>80</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>Royal College</td>
                                            <td>75</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div id='junior'>
                            <h1 id='category_title'>Junior</h1>
                            <div id='table_container'>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Rank</th>
                                            <th>School</th>
                                            <th>Score</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>D.S. Senanayake College</td>
                                            <td>90</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Richmond College</td>
                                            <td>85</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>Royal College</td>
                                            <td>80</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Results